import React from "react";
import { Button, TextInput } from "@mantine/core";
import { ReactComponent as PasswordIcon } from "@/assets/icons/password.svg";
import { ReactComponent as ChevronRightIcon } from "@/assets/icons/chevron-right.svg";
import { ReactComponent as DeleteIcon } from "@/assets/icons/delete.svg";
import { PersonalDataFormType } from "@/pages/User/Profile/Profile";
import "./Steps.css";

interface PasswordDataProps {
  formData: PersonalDataFormType;
  saveMyDetails: (values: {
    firstName: string;
    lastName: string;
    email: string;
  }) => void;
  goToPassword?: () => void;
  open?: () => void;
}

const Password: React.FC<PasswordDataProps> = ({
  formData,
  saveMyDetails,
  goToPassword,
  open,
}) => {
  return (
    <div>
      <form
        className="personal-data-form"
        onSubmit={formData.onSubmit(saveMyDetails)}
      >
        <div className="text-[#004a99] text-base font-bold">Osobni podaci</div>
        <div className="personal-data-inputs">
          <TextInput
            className="flex-1"
            label="Ime"
            placeholder="Ime"
            key={formData.key("firstName")}
            {...formData.getInputProps("firstName")}
          />
          <TextInput
            className="flex-1"
            label="Prezime"
            placeholder="Prezime"
            key={formData.key("lastName")}
            {...formData.getInputProps("lastName")}
          />
          <TextInput
            className="flex-1"
            label="E-mail"
            placeholder="email@mail.com"
            key={formData.key("email")}
            {...formData.getInputProps("email")}
          />
        </div>
        <div className="change-password-container" onClick={goToPassword}>
          <div className="flex gap-3 items-center">
            <PasswordIcon className="text-[#004a99]" />
            <div className="text-[#004a99] text-base font-bold">
              Promjena lozinke
            </div>
          </div>
          <ChevronRightIcon className="text-[#004a99]" />
        </div>
        <div className="personal-data-buttons">
          {window.innerWidth > 665 && open && (
            <Button
              variant="transparent"
              color="#f40c0c"
              leftSection={<DeleteIcon />}
              onClick={() => open()}
            >
              Obriši račun
            </Button>
          )}
          <Button
            type="submit"
            variant="filled"
            color="#004a99"
            radius="xl"
            size="md"
            className="personal-data-save-button"
          >
            Spremi{window.innerWidth > 665 && " promjene"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Password;
